import { useMemo } from 'react'

import { parse } from 'date-fns'

export const useAppCycleStartDate = (applicationCycle: number) => {
  return useMemo(() => parse(`08/01/${applicationCycle - 1}`, 'MM/dd/yyyy', new Date()), [applicationCycle])
}

export const useAppCycleYearRange = (applicationCycle: number) => {
  return useMemo(() => `${applicationCycle - 1}-${applicationCycle}`, [applicationCycle])
}

export const useAppCycleEndDate = (applicationCycle: number) => {
  return useMemo(() => parse(`07/31/${applicationCycle} 23:59:59`, 'MM/dd/yyyy HH:m:s', new Date()), [applicationCycle])
}
